import { useSelector } from "react-redux";

/**
 * Returns user rights for the current user.
 */
export const useUserRights = () => {
    // @ts-ignore
    return useSelector((state) => state.vdsmUser.rights?.[0]);
};
